import React, {ReactNode, useState} from 'react';
import styles from './Popover.module.css'
import clsx from "clsx";


interface IProps {
    children: ReactNode,
    isOpen: boolean,
    setIsOpen: (boolean: boolean) => void
}

const Popover = ({children, isOpen, setIsOpen}: IProps) => {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isProcessClose, setIsProcessClose] = useState<boolean>(false)


    return (
        <div className={
            clsx(
                styles.popoverWrapper,
                isOpen && styles.popoverOpen,
                isProcessClose && styles.processClose
            )}>
            {children}
        </div>
    )

};

export default Popover;